<template>
    <div class="body">
        <el-form ref="form" class="form" :model="form" label-width="80px">
            <el-form-item  label="入离时间:">
                <span>入住时间:</span>
                <el-input class="timeInput" v-model="input" placeholder="请输入内容"></el-input>
                <span>后、 离店时间:</span>
                <el-input class="timeInput" v-model="input" placeholder="请输入内容"></el-input> 
                <span class="timeStart">前</span>
            </el-form-item>
            <el-form-item  label="宠物:">
                <el-radio v-model="radio" name="pet" label="1">可携带宠物</el-radio>
                <el-radio class="pet" v-model="radio" name="pet" label="2">不可携带宠物</el-radio>
            </el-form-item>
            <el-form-item  label="儿童政策:">
                <el-radio v-model="policy" label="1"  class="policy1">不接受18岁以下客人单独入住</el-radio><br/>
                <el-radio v-model="policy" label="2"  class="policy2">18岁以下儿童加床收费、每晚RMB<el-input class="timeInput" v-model="input" placeholder=""></el-input>、不含儿童早餐</el-radio><br/>
                <el-radio v-model="policy" label="3"  class="policy3">18岁以下儿童使用现有床铺免费、不含儿童早餐</el-radio><br/>
                <el-radio v-model="policy" label="4"  class="policy4">儿童身高<el-input class="timeInput" v-model="input" placeholder=""></el-input>、米以下早餐按照成人标准半价收费</el-radio><br/>
                <el-radio v-model="policy" label="5"  class="policy5">儿童身高<el-input class="timeInput" v-model="input" placeholder=""></el-input>、米以下早餐按照成人标准半价收费</el-radio><br/>
            </el-form-item>
            <el-form-item  label="餐食政策:">
                <span>种类:</span>
                <el-select v-model="value" placeholder="请选择"  class="foodClass">
                    <el-option  v-for="item in kind" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <br/>
                <br/>
                <span>形式:</span>
                <el-select v-model="value1" placeholder="请选择" class="foodShape">
                    <el-option  v-for="item in shape" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <br/>
                <br/>
                <span>价格:</span>
                <el-input class="timeInput foodPrice" v-model="input" placeholder="请输入内容"></el-input><br/>
                <br/>
                <span>时间:</span>
                <el-time-picker is-range v-model="value2" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" class="foodTime"></el-time-picker>
            </el-form-item>
             <el-form-item  label="酒店提示:">
                 <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="textarea"></el-input>
            </el-form-item>
            <el-form-item  label="订单确认:">
                <el-input-number v-model="num" @change="handleChange" :min="1" :step="10" :max="100" label="描述文字"></el-input-number><span class="foodOrder">分钟内确认</span>
            </el-form-item>
             <el-form-item>
                <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
  data() {
    return {
      input: '',
      radio: '1',
      policy:'1',
      checkList: ['选中且禁用','复选框 A'],
      kind: [{
          value: '选项1',
          label: '中餐'
        }, {
          value: '选项2',
          label: '西餐'
        }, {
          value: '选项3',
          label: '中餐、西餐'
        }],
        value: '',
        shape: [{
          value: '选项1',
          label: '单点'
        }, {
          value: '选项2',
          label: '自助'
        }],
        value1: '',
        value2: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
        textarea: '',
        num: 10
    }
  },
  methods: {
      handleChange(value) {
        console.log(value);
      }
    }
}
</script>

<style scoped>

.form{
    padding-top: 1%;
    padding-bottom: 1%;
}

.timeInput{
    width: 10%;
}

.timeStart{
  margin-right: 60%;
}

.pet{
  margin-right: 77%;
}

.policy1{
  margin-right: 79%;
}

.policy2{
  margin-right: 68%;
}

.policy3{
  margin-right: 72%;
}

.policy4{
  margin-right: 70%;
}

.policy5{
  margin-right: 70%;
}

.foodClass{
  margin-right: 75%;
}

.foodShape{
  margin-right: 75%;
}

.foodPrice{
  margin-right: 79%;
}

.foodTime{
  margin-right: 67%;
}

.foodOrder{
  margin-right: 75%;
}

</style>



// WEBPACK FOOTER //
// src/components/Hotel/product/setup/hotelRoom.vue